import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-target-glow-svg',
  standalone: true,
  template: `
    <svg width="248" height="223" viewBox="0 0 248 223" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.4" filter="url(#filter_glow_target_svg)">
        <path
          d="M167.698 111.245C167.698 128.668 147.999 142.792 123.698 142.792C99.3975 142.792 79.698 128.668 79.698 111.245C79.698 93.8223 99.3975 79.6981 123.698 79.6981C147.999 79.6981 167.698 93.8223 167.698 111.245Z"
          [attr.fill]="color()"/>
      </g>
      <defs>
        <filter id="filter_glow_target_svg" x="-0.000114441" y="7.62939e-06" width="247.396" height="222.491"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="39.8491" result="effect1_foregroundBlur"/>
        </filter>
      </defs>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
    }
    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetGlowSvgComponent {
  readonly color = input.required<string>();
  readonly pulse = input<boolean>(false);
}
